import { PhoneNumberType, phoneNumberTypes } from '@/core/models/phone-number.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Country } from './country.interface';
import { CountryService } from './country.service';
import { StoreState } from '@/core/models/store.interface';

const service = new CountryService();

export interface CountryState {
   countries: Array<Country>;
   phoneNumberTypes: Array<PhoneNumberType>;
}

const CountryStore: Module<CountryState, StoreState> = {
   namespaced: true,
   state: {
      countries: [],
      phoneNumberTypes: [...phoneNumberTypes],
   },
   getters: {
      countries: (state) => state.countries,
      phoneNumberTypes: (state) => state.phoneNumberTypes,
   },
   mutations: {
      SET_COUNTRIES(state, countries: Array<Country>) {
         state.countries = countries;
      },
   },
   actions: {
      async getCountries(context, query: LocationQuery) {
         const countries = await service.getCountries({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_COUNTRIES', countries);
         return countries;
      },
   },
};

export default CountryStore;
